// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import {router} from './router'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import BreadcrumbGroup from './components/breadcrumb/BreadcrumbGroup'
import VueScrollTo from 'vue-scrollto'
import VueLodash from 'vue-lodash'
import VueGtm from 'vue-gtm'

import { Collapse, Modal, Tooltip } from 'bootstrap-vue/es/components'
Vue.component('breadcrumb-group', BreadcrumbGroup)
Vue.use(Collapse)
Vue.use(Modal)
Vue.use(Tooltip)

Vue.use(VueAwesomeSwiper)
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VueScrollTo)
Vue.use(VueLodash)

Vue.use(VueGtm, {
  id: 'GTM-5MRJPKX',
  enabled: false,
  debug: false,
  ignoredViews: []
})

Vue.config.productionTip = false

const i18nData = require('./locales/view/ja.json')
const i18n = new VueI18n({
  locale: 'ja',
  messages: i18nData
})

Vue.filter(
  'numberToCurrency', function (value) {
    return Number(value).toLocaleString() + '円'
  })
Vue.filter(
  'numberToPercentage', function (value) {
    return value.toLocaleString() + '%'
  })
Vue.filter(
  'numberWithDelimiter', function (value) {
    return Number(value).toLocaleString()
  })
Vue.filter('ymdDateFormat', function (value, fmt = null) {
  if (fmt) {
    return value.toString().substr(0, 4) + fmt + (value.toString().substr(4, 2) ? String(Number(value.toString().substr(4, 2))) : '') + fmt + (value.toString().substr(6, 2) ? String(Number(value.toString().substr(6, 2))) : '')
  }
  return value.toString().substr(0, 4) + '年' + (value.toString().substr(4, 2) ? String(Number(value.toString().substr(4, 2))) : '') + '月' + (value.toString().substr(6, 2) ? String(Number(value.toString().substr(6, 2))) : '') + '日'
})

Vue.mixin({
  methods: {
    goToErrorPage (e) {
      // console.error('Error!!!!!', e)
      if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering) {
        return
      }
      if (e && e.toString().indexOf('api_status') !== -1) {
        return
      }
      this.$router.push({ name: 'InternalServerError' })
    },
    scrollTop () {
      this.$scrollTo(document.getElementsByTagName('body'), 300, {easing: 'ease'})
    },
    trackGtmEvent (category, action) {
      this.$gtm.trackEvent({event: 'click', category: category, action: action})
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n: i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js